import { useNavigate } from "react-router-dom";
import ajaxStations from "../../util/remote/ajaxStations";
import { useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import ajaxStationOwners from "../../util/remote/ajaxStationOwners";
const RegisterstationsGroupsModal = (props) => {
  // validation
  const navigate = useNavigate();
  // Form fields
  const [loading, setLoading] = useState(false);
  const [stationOwnerNames, setStationOwnerNames] = useState("");
  const [contact, setContact] = useState("");
  const [contact2, setContact2] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  // Validation
  const allRowsFilled = () => stationOwnerNames && contact && email && address;
  // Handle form submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!allRowsFilled()) {
      toast.error("Please complete all required fields");
      return;
    }
    const data = {
      station_owner_names: stationOwnerNames,
      contact,
      contact2,
      email,
      address,
    };
    setLoading(true);
    const response = await ajaxStationOwners.createstation_owners(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      props.func();
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setStationOwnerNames("");
    setContact("");
    setContact2("");
    setEmail("");
    setAddress("");
  };
  const RenderFooter = (controls) => (
    <>
      <button className="btn btn-secondary" onClick={controls.close}>
        Close
      </button>
      <button
        className="btn btn-primary"
        onClick={(e) => handleAdd(e, controls.close)}
        disabled={!allRowsFilled() || loading}
      >
        {loading ? <Loader /> : "Register Owner"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Creating Fuel Station Group"
      size="md"
      footer={RenderFooter}
    >
      <Toaster />
      {loading && <Loader />}
      <div className="container-fluid">
        <Toaster />

        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Register Station Owner</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-3">
                    {/* Owner Names */}
                    <div className="col-md-12">
                      <label>
                        Owner Names <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={stationOwnerNames}
                        onChange={(e) => setStationOwnerNames(e.target.value)}
                        className="form-control"
                        placeholder="Enter owner names"
                        required
                      />
                    </div>
                    {/* Contact */}
                    <div className="col-md-12 mt-3">
                      <label>
                        Primary Contact <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        value={contact}
                        onChange={(e) => setContact(e.target.value)}
                        className="form-control"
                        placeholder="Enter primary contact number"
                        required
                      />
                    </div>
                    {/* Secondary Contact */}
                    <div className="col-md-12 mt-3">
                      <label>Secondary Contact</label>
                      <input
                        type="text"
                        value={contact2}
                        onChange={(e) => setContact2(e.target.value)}
                        className="form-control"
                        placeholder="Enter secondary contact number (optional)"
                      />
                    </div>
                    {/* Email */}
                    <div className="col-md-12 mt-3">
                      <label>
                        Email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control"
                        placeholder="Enter email address"
                        required
                      />
                    </div>
                    {/* Address */}
                    <div className="col-md-12 mt-3">
                      <label>
                        Address <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        className="form-control"
                        placeholder="Enter station address"
                        rows={2} // You can adjust the number of visible rows
                        required
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SystemModal>
  );
};
export default RegisterstationsGroupsModal;
